export default "__VITE_ASSET__DnHhqptB__"